export const DIAS_SEMANA = [
  { key: "lunes", label: "L", nombre: "Lunes" },
  { key: "martes", label: "M", nombre: "Martes" },
  { key: "miercoles", label: "X", nombre: "Miércoles" },
  { key: "jueves", label: "J", nombre: "Jueves" },
  { key: "viernes", label: "V", nombre: "Viernes" },
  { key: "sabado", label: "S", nombre: "Sábado" },
  { key: "domingo", label: "D", nombre: "Domingo" }
];
